import { combineReducers } from 'redux';
import alertReducer from '../alert/alert.reducer';
import authReducer from '../auth/auth.reducer';
import dicomReducer from '../dicom/dicom.reducer';
import enumsReducer from '../enums/enums.reducer';
import profileReducer from '../profile/profile.reducer';
import spinnerReducer from '../spinner/spinner.reducer';
import trainingReducer from '../training/training.reducer';

const rootReducer = combineReducers({
  alert: alertReducer,
  auth: authReducer,
  profile: profileReducer,
  training: trainingReducer,
  spinner: spinnerReducer,
  enums: enumsReducer,
  dicom: dicomReducer,
});

export default rootReducer;
